import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";

import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import Typography from "@material-ui/core/Typography";

import api from "../../services/api";
import ButtonWithSpinner from "../ButtonWithSpinner";
import toastError from "../../errors/toastError";

const ExternalTicketTransferModal = ({ open, onClose, ticketId }) => {
  const [platforms, setPlatforms] = useState([]);
  const [selectedPlatformId, setSelectedPlatformId] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const loadPlatforms = async () => {
      if (!open) return;

      try {
        const { data } = await api.get("/external-platforms");
        setPlatforms((data || []).filter(platform => platform.active !== false));
      } catch (err) {
        toastError(err);
      }
    };

    loadPlatforms();
  }, [open]);

  const handleClose = () => {
    setSelectedPlatformId("");
    onClose();
  };

  const handleTransfer = async () => {
    if (!ticketId || !selectedPlatformId) return;

    setLoading(true);
    try {
      await api.post(`/tickets/${ticketId}/transfer-external`, {
        externalPlatformId: selectedPlatformId
      });
      toast.success("Conversa transferida para a plataforma externa.");
      handleClose();
    } catch (err) {
      toastError(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>Transferir para plataforma externa</DialogTitle>
      <DialogContent dividers>
        <Typography variant="body2" style={{ marginBottom: 16 }}>
          Selecione a plataforma que recebera uma copia do contato, atendimento e
          mensagens desta conversa.
        </Typography>
        <FormControl variant="outlined" fullWidth>
          <InputLabel>Plataforma</InputLabel>
          <Select
            value={selectedPlatformId}
            onChange={e => setSelectedPlatformId(e.target.value)}
            label="Plataforma"
          >
            <MenuItem value="">
              <em>Selecione</em>
            </MenuItem>
            {platforms.map(platform => (
              <MenuItem key={platform.id} value={platform.id}>
                {platform.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={handleClose}
          color="secondary"
          variant="outlined"
          disabled={loading}
        >
          Cancelar
        </Button>
        <ButtonWithSpinner
          color="primary"
          variant="contained"
          loading={loading}
          disabled={loading || !selectedPlatformId}
          onClick={handleTransfer}
        >
          Transferir
        </ButtonWithSpinner>
      </DialogActions>
    </Dialog>
  );
};

export default ExternalTicketTransferModal;
